import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Section} from "../../../../../framework/model/core/sections/section";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {IonSlides} from "@ionic/angular";
import {Events} from "../../../../../framework/providers/events";

@Component({
    selector: 'app-sections-grid-slider',
    templateUrl: './sections-grid-slider.component.html',
    styleUrls: ['./sections-grid-slider.component.scss']
})
export class SectionsGridSliderComponent implements OnInit {
    @ViewChild(IonSlides) slidesEL: IonSlides;
    public models: Array<Section> = [];
    public prefix = 'sectionsgrid'
    @Input() options: object = {rows: 2, cols: 8};

    public slides = [];

    constructor(public tools: ModelToolsProvider, public events: Events,) {
    }

    ngOnInit() {
        // Initialization logic can go here
        this.options = {
            ...this.options,
            'slidesPerView': this.options['cols']
        };


        this.events.subscribe(this.prefix + '_modelUpdated', (res) => {
            this.setSlides();
        })
    }


    ngOnDestroy()
    {
        this.events.unsubscribe(this.prefix + '_modelUpdated')
    }

    ngAfterViewInit() {
    }

    setSlides() {
        this.slides.length = 0;
        const numSectionsPerSlide = this.options['rows']// * this.options.cols;
        let slides = [];

        for (let i = 0; i < this.models.length; i += numSectionsPerSlide) {
            slides.push(this.models.slice(i, i + numSectionsPerSlide));
        }

        this.slides = slides;
    }

    slideNext() {
        this.slidesEL.slideNext();
    }

    slidePrev() {
        this.slidesEL.slidePrev();
    }

    goTo(model) {
        this.tools.goTo('section/' + model.data['id']);
    }

}
